/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AdminEmissionsRecordsStatsListProviderWithSourceParameterInner,
    AdminEmissionsRecordsStatsListProviderWithSourceParameterInnerFromJSON,
    AdminEmissionsRecordsStatsListProviderWithSourceParameterInnerToJSON,
} from '../models/AdminEmissionsRecordsStatsListProviderWithSourceParameterInner';
import {
    type GroupedBySiteType,
    GroupedBySiteTypeFromJSON,
    GroupedBySiteTypeToJSON,
} from '../models/GroupedBySiteType';
import {
    type PaginatedSiteAnalyticsList,
    PaginatedSiteAnalyticsListFromJSON,
    PaginatedSiteAnalyticsListToJSON,
} from '../models/PaginatedSiteAnalyticsList';
import {
    type PaginatedSiteEmissionsAvgList,
    PaginatedSiteEmissionsAvgListFromJSON,
    PaginatedSiteEmissionsAvgListToJSON,
} from '../models/PaginatedSiteEmissionsAvgList';
import {
    type PaginatedSiteMapAnalyticsList,
    PaginatedSiteMapAnalyticsListFromJSON,
    PaginatedSiteMapAnalyticsListToJSON,
} from '../models/PaginatedSiteMapAnalyticsList';
import {
    type QuarterEmissions,
    QuarterEmissionsFromJSON,
    QuarterEmissionsToJSON,
} from '../models/QuarterEmissions';
import {
    type QuarterNonDetects,
    QuarterNonDetectsFromJSON,
    QuarterNonDetectsToJSON,
} from '../models/QuarterNonDetects';

export interface AnalyticsEmissionsCountsPerQuarterListRequest {
    dataProviderHasNonDetects?: boolean;
    detectionThresholdGte?: number;
    detectionThresholdLt?: number;
    locationPreset?: Array<number>;
    ordering?: string;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    siteType?: Array<string>;
    timestampAfter?: Date;
    timestampBefore?: Date;
}

export interface AnalyticsEmissionsCountsPerSiteTypeListRequest {
    dataProviderHasNonDetects?: boolean;
    detectionThresholdGte?: number;
    detectionThresholdLt?: number;
    locationPreset?: Array<number>;
    ordering?: string;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    siteType?: Array<string>;
    timestampAfter?: Date;
    timestampBefore?: Date;
}

export interface AnalyticsEmissionsDailyAveragesListRequest {
    dataProviderHasNonDetects?: boolean;
    detectionThresholdGte?: number;
    detectionThresholdLt?: number;
    locationPreset?: Array<number>;
    ordering?: string;
    page?: number;
    pageSize?: number;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    siteType?: Array<string>;
    timestampAfter?: Date;
    timestampBefore?: Date;
}

export interface AnalyticsMapSiteAnalyticsListRequest {
    cursor?: string;
    detectionThreshold?: number;
    locationPreset?: Array<number>;
    locationWithin?: string;
    providerWithSource?: string;
    siteType?: Array<string>;
    timestampAfter?: Date;
    timestampBefore?: Date;
}

export interface AnalyticsNondetectsCountsPerQuarterListRequest {
    detectionThreshold?: number;
    locationPreset?: Array<number>;
    ordering?: string;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    siteType?: Array<string>;
    timestampAfter?: Date;
    timestampBefore?: Date;
}

export interface AnalyticsNondetectsCountsPerSiteTypeListRequest {
    detectionThreshold?: number;
    locationPreset?: Array<number>;
    ordering?: string;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    siteType?: Array<string>;
    timestampAfter?: Date;
    timestampBefore?: Date;
}

export interface AnalyticsSitesListRequest {
    detectionThreshold?: number;
    locationPreset?: Array<number>;
    page?: number;
    pageSize?: number;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    siteType?: Array<string>;
    timestampAfter?: Date;
    timestampBefore?: Date;
}

/**
 * 
 */
export class AnalyticsApi extends runtime.BaseAPI {

    /**
     * Creates request options for analyticsEmissionsCountsPerQuarterList without sending the request
     */
    async analyticsEmissionsCountsPerQuarterListRequestOpts(requestParameters: AnalyticsEmissionsCountsPerQuarterListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['dataProviderHasNonDetects'] != null) {
            queryParameters['data_provider_has_non_detects'] = requestParameters['dataProviderHasNonDetects'];
        }

        if (requestParameters['detectionThresholdGte'] != null) {
            queryParameters['detection_threshold_gte'] = requestParameters['detectionThresholdGte'];
        }

        if (requestParameters['detectionThresholdLt'] != null) {
            queryParameters['detection_threshold_lt'] = requestParameters['detectionThresholdLt'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['siteType'] != null) {
            queryParameters['site_type'] = requestParameters['siteType']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['timestampAfter'] != null) {
            queryParameters['timestamp_after'] = (requestParameters['timestampAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['timestampBefore'] != null) {
            queryParameters['timestamp_before'] = (requestParameters['timestampBefore'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/analytics/emissions/counts_per_quarter/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Computes and return the count of emissions by quarter.
     */
    async analyticsEmissionsCountsPerQuarterListRaw(requestParameters: AnalyticsEmissionsCountsPerQuarterListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<QuarterEmissions>>> {
        const requestOptions = await this.analyticsEmissionsCountsPerQuarterListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(QuarterEmissionsFromJSON));
    }

    /**
     * Computes and return the count of emissions by quarter.
     */
    async analyticsEmissionsCountsPerQuarterList(requestParameters: AnalyticsEmissionsCountsPerQuarterListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<QuarterEmissions>> {
        const response = await this.analyticsEmissionsCountsPerQuarterListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for analyticsEmissionsCountsPerSiteTypeList without sending the request
     */
    async analyticsEmissionsCountsPerSiteTypeListRequestOpts(requestParameters: AnalyticsEmissionsCountsPerSiteTypeListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['dataProviderHasNonDetects'] != null) {
            queryParameters['data_provider_has_non_detects'] = requestParameters['dataProviderHasNonDetects'];
        }

        if (requestParameters['detectionThresholdGte'] != null) {
            queryParameters['detection_threshold_gte'] = requestParameters['detectionThresholdGte'];
        }

        if (requestParameters['detectionThresholdLt'] != null) {
            queryParameters['detection_threshold_lt'] = requestParameters['detectionThresholdLt'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['siteType'] != null) {
            queryParameters['site_type'] = requestParameters['siteType']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['timestampAfter'] != null) {
            queryParameters['timestamp_after'] = (requestParameters['timestampAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['timestampBefore'] != null) {
            queryParameters['timestamp_before'] = (requestParameters['timestampBefore'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/analytics/emissions/counts_per_site_type/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Computes and return the count of emissions by site_type
     */
    async analyticsEmissionsCountsPerSiteTypeListRaw(requestParameters: AnalyticsEmissionsCountsPerSiteTypeListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GroupedBySiteType>>> {
        const requestOptions = await this.analyticsEmissionsCountsPerSiteTypeListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GroupedBySiteTypeFromJSON));
    }

    /**
     * Computes and return the count of emissions by site_type
     */
    async analyticsEmissionsCountsPerSiteTypeList(requestParameters: AnalyticsEmissionsCountsPerSiteTypeListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GroupedBySiteType>> {
        const response = await this.analyticsEmissionsCountsPerSiteTypeListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for analyticsEmissionsDailyAveragesList without sending the request
     */
    async analyticsEmissionsDailyAveragesListRequestOpts(requestParameters: AnalyticsEmissionsDailyAveragesListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['dataProviderHasNonDetects'] != null) {
            queryParameters['data_provider_has_non_detects'] = requestParameters['dataProviderHasNonDetects'];
        }

        if (requestParameters['detectionThresholdGte'] != null) {
            queryParameters['detection_threshold_gte'] = requestParameters['detectionThresholdGte'];
        }

        if (requestParameters['detectionThresholdLt'] != null) {
            queryParameters['detection_threshold_lt'] = requestParameters['detectionThresholdLt'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['siteType'] != null) {
            queryParameters['site_type'] = requestParameters['siteType']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['timestampAfter'] != null) {
            queryParameters['timestamp_after'] = (requestParameters['timestampAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['timestampBefore'] != null) {
            queryParameters['timestamp_before'] = (requestParameters['timestampBefore'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/analytics/emissions/daily_averages/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Computes daily averages for all emissions found.
     */
    async analyticsEmissionsDailyAveragesListRaw(requestParameters: AnalyticsEmissionsDailyAveragesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedSiteEmissionsAvgList>> {
        const requestOptions = await this.analyticsEmissionsDailyAveragesListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedSiteEmissionsAvgListFromJSON(jsonValue));
    }

    /**
     * Computes daily averages for all emissions found.
     */
    async analyticsEmissionsDailyAveragesList(requestParameters: AnalyticsEmissionsDailyAveragesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedSiteEmissionsAvgList> {
        const response = await this.analyticsEmissionsDailyAveragesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for analyticsMapSiteAnalyticsList without sending the request
     */
    async analyticsMapSiteAnalyticsListRequestOpts(requestParameters: AnalyticsMapSiteAnalyticsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['detectionThreshold'] != null) {
            queryParameters['detection_threshold'] = requestParameters['detectionThreshold'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['siteType'] != null) {
            queryParameters['site_type'] = requestParameters['siteType']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['timestampAfter'] != null) {
            queryParameters['timestamp_after'] = (requestParameters['timestampAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['timestampBefore'] != null) {
            queryParameters['timestamp_before'] = (requestParameters['timestampBefore'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/analytics/map-site-analytics/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Paginated per-site map analytics (emission/non-detect counts + location).
     */
    async analyticsMapSiteAnalyticsListRaw(requestParameters: AnalyticsMapSiteAnalyticsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedSiteMapAnalyticsList>> {
        const requestOptions = await this.analyticsMapSiteAnalyticsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedSiteMapAnalyticsListFromJSON(jsonValue));
    }

    /**
     * Paginated per-site map analytics (emission/non-detect counts + location).
     */
    async analyticsMapSiteAnalyticsList(requestParameters: AnalyticsMapSiteAnalyticsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedSiteMapAnalyticsList> {
        const response = await this.analyticsMapSiteAnalyticsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for analyticsNondetectsCountsPerQuarterList without sending the request
     */
    async analyticsNondetectsCountsPerQuarterListRequestOpts(requestParameters: AnalyticsNondetectsCountsPerQuarterListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['detectionThreshold'] != null) {
            queryParameters['detection_threshold'] = requestParameters['detectionThreshold'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['siteType'] != null) {
            queryParameters['site_type'] = requestParameters['siteType']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['timestampAfter'] != null) {
            queryParameters['timestamp_after'] = (requestParameters['timestampAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['timestampBefore'] != null) {
            queryParameters['timestamp_before'] = (requestParameters['timestampBefore'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/analytics/nondetects/counts_per_quarter/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Computes and returns the count of non-detects by quarter.  Aggregates SiteNonDetect records by quarter, data provider, and secondary data source. Supports filtering by: - timestamp: Date range (auto-expanded to full quarters) - detection_threshold: Minimum detection limit - provider_with_source: Provider and secondary source filtering - location_preset: Geographic filtering
     */
    async analyticsNondetectsCountsPerQuarterListRaw(requestParameters: AnalyticsNondetectsCountsPerQuarterListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<QuarterNonDetects>>> {
        const requestOptions = await this.analyticsNondetectsCountsPerQuarterListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(QuarterNonDetectsFromJSON));
    }

    /**
     * Computes and returns the count of non-detects by quarter.  Aggregates SiteNonDetect records by quarter, data provider, and secondary data source. Supports filtering by: - timestamp: Date range (auto-expanded to full quarters) - detection_threshold: Minimum detection limit - provider_with_source: Provider and secondary source filtering - location_preset: Geographic filtering
     */
    async analyticsNondetectsCountsPerQuarterList(requestParameters: AnalyticsNondetectsCountsPerQuarterListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<QuarterNonDetects>> {
        const response = await this.analyticsNondetectsCountsPerQuarterListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for analyticsNondetectsCountsPerSiteTypeList without sending the request
     */
    async analyticsNondetectsCountsPerSiteTypeListRequestOpts(requestParameters: AnalyticsNondetectsCountsPerSiteTypeListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['detectionThreshold'] != null) {
            queryParameters['detection_threshold'] = requestParameters['detectionThreshold'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['siteType'] != null) {
            queryParameters['site_type'] = requestParameters['siteType']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['timestampAfter'] != null) {
            queryParameters['timestamp_after'] = (requestParameters['timestampAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['timestampBefore'] != null) {
            queryParameters['timestamp_before'] = (requestParameters['timestampBefore'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/analytics/nondetects/counts_per_site_type/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Computes and return the count of non_detects by site_type
     */
    async analyticsNondetectsCountsPerSiteTypeListRaw(requestParameters: AnalyticsNondetectsCountsPerSiteTypeListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GroupedBySiteType>>> {
        const requestOptions = await this.analyticsNondetectsCountsPerSiteTypeListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GroupedBySiteTypeFromJSON));
    }

    /**
     * Computes and return the count of non_detects by site_type
     */
    async analyticsNondetectsCountsPerSiteTypeList(requestParameters: AnalyticsNondetectsCountsPerSiteTypeListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GroupedBySiteType>> {
        const response = await this.analyticsNondetectsCountsPerSiteTypeListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for analyticsSitesList without sending the request
     */
    async analyticsSitesListRequestOpts(requestParameters: AnalyticsSitesListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['detectionThreshold'] != null) {
            queryParameters['detection_threshold'] = requestParameters['detectionThreshold'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['siteType'] != null) {
            queryParameters['site_type'] = requestParameters['siteType']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['timestampAfter'] != null) {
            queryParameters['timestamp_after'] = (requestParameters['timestampAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['timestampBefore'] != null) {
            queryParameters['timestamp_before'] = (requestParameters['timestampBefore'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/analytics/sites/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List sites by emission ratio, with a cached response.
     */
    async analyticsSitesListRaw(requestParameters: AnalyticsSitesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedSiteAnalyticsList>> {
        const requestOptions = await this.analyticsSitesListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedSiteAnalyticsListFromJSON(jsonValue));
    }

    /**
     * List sites by emission ratio, with a cached response.
     */
    async analyticsSitesList(requestParameters: AnalyticsSitesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedSiteAnalyticsList> {
        const response = await this.analyticsSitesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for analyticsSitesSiteTypesRetrieve without sending the request
     */
    async analyticsSitesSiteTypesRetrieveRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/analytics/sites/site_types/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a list of all unique site types available to the user.  Used by the frontend to display available site type options for filtering. Does not apply filters - returns all site types the user has access to.
     */
    async analyticsSitesSiteTypesRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const requestOptions = await this.analyticsSitesSiteTypesRetrieveRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns a list of all unique site types available to the user.  Used by the frontend to display available site type options for filtering. Does not apply filters - returns all site types the user has access to.
     */
    async analyticsSitesSiteTypesRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.analyticsSitesSiteTypesRetrieveRaw(initOverrides);
        return await response.value();
    }

}
